import React from 'react';
import Projects from '../components/Projects/Projects';

const Portfolio = () => <Projects />;
export default Portfolio;
